import React, {useState,useEffect} from 'react';
import useFunctions2  from 'components/pages/aporteDocumentacion/AporteDocumentacionFunction';
import {properties} from 'components/pages/aporteDocumentacion/AporteDocumentacionData';

const useFunctions = () => {

    const [mostrarPDF, setMostrarPDF] = useState(false);
    const [loadingProps, setLoadingProps] = useState(true);
    const [formatosImagen, setFormatosImagen] = useState([]);
    const [formatosVideo, setFormatosVideo] = useState([]);
    const { getStorageProperties } = useFunctions2();
    /**
     * @function cerrarPopUpPdf Actualiza el hook que controla el pop up para visualizar pdfs y lo cierra
     */
     const cerrarPopUpPdf = () =>{
        setMostrarPDF(false);
    };

    /**
     * @function cerrarPopUpPdf Actualiza el hook que controla el pop up para visualizar pdfs y lo cierra
     */
     const cortarTexto = (texto) =>{
        return (texto.length <= 90) ? (texto) : (texto.substring(0, 90) + '...');
    };

    /**
     * @function mostrarPopUpPdf Actualiza el hook que controla el pop up para visualizar pdfs y lo abre
     */
     const mostrarPopUpPdf = () =>{
        setMostrarPDF(true);
    };

   useEffect(() => {
     getStorageProperties().then(() => {
       setFormatosImagen(properties.ALLOWEDIMAGEFORMATS?.split(',').map(ext => ext.toLowerCase().trim()) ?? []);
       setFormatosVideo(properties.ALLOWEDVIDEOFORMATS?.split(',').map(ext => ext.toLowerCase().trim()) ?? []);
       setLoadingProps(false);
     });
   }, []);


    const obtenerTipoFichero = (doc) => {
        if (loadingProps || !doc) return 'otro';
        const nombre = doc.nombreArchivo || doc.texto;
        if (!nombre || nombre.endsWith('...')) return 'pdf';
        const extension = '.' + nombre.substring(nombre.lastIndexOf('.') + 1).toLowerCase();
        if (extension === '.pdf') return 'pdf';
        if (formatosImagen.includes(extension)) return 'image';
        if (formatosVideo.includes(extension)) return 'video';
        return 'otro';
    };

    return { mostrarPDF, cerrarPopUpPdf, mostrarPopUpPdf, cortarTexto, obtenerTipoFichero};

}
export default useFunctions;